<!-- Day Tabs Navigation -->
@if (eventDays.length > 0) {
  <div class="day-tabs-wrapper">
    <div class="day-tabs">
      @for (day of eventDays; track day.date.getTime()) {
        <button class="day-tab"
                [class.active]="selectedDay && isSameDay(selectedDay, day.date)"
                [class.today]="day.isToday"
                (click)="selectDay(day)">
          <span class="day-label">{{ day.label }}</span>
          <span class="day-label-short">{{ day.shortLabel }}</span>
          @if (getClassCountForDay(day) > 0) {
            <span class="day-count">{{ getClassCountForDay(day) }}</span>
          }
        </button>
      }
    </div>
  </div>
}

@if (loading) {
  <div class="loading-container">
    <div class="loading-spinner"></div>
    <p>{{ 'manageEvent.classes.loading' | translate }}</p>
  </div>
} @else {
  <div class="card card-flush mb-9">
    <div class="card-header mt-5">
      <div class="card-title flex-column">
        <h3 class="fw-bold mb-1">{{ 'manageEvent.classes.title' | translate }}</h3>
        <div class="fs-6 text-gray-500">
          @if (selectedDay) {
            {{ filteredClasses?.length || 0 }} {{ 'manageEvent.classes.classesOnDay' | translate }} ({{ eventClasses.length }} {{ 'manageEvent.classes.total' | translate }})
          } @else {
            {{ 'manageEvent.classes.totalClasses' | translate }} {{ eventClasses.length }}
          }
        </div>
      </div>
      <div class="card-toolbar my-1">
        <app-button
          [variant]="'primary'"
          [label]="'manageEvent.classes.addClass' | translate"
          [iconClass]="'fa fa-plus'"
          [size]="'md'"
          class="ms-2"
          (clicked)="openAddEventClassModal()"
        />
      </div>
    </div>
    <div class="card-body pt-0">
      @if (filteredClasses?.length === 0) {
        <div class="text-center py-10 text-muted">
          <i class="fa fa-calendar-xmark fs-3x mb-4 d-block opacity-50"></i>
          <p class="mb-0">{{ 'manageEvent.classes.noClasses' | translate }}</p>
          <p class="fs-7">{{ 'manageEvent.classes.noClassesHint' | translate }}</p>
        </div>
      } @else {
        <div class="table-responsive">
          <table id="kt_profile_overview_table" class="table table-row-bordered table-row-dashed gy-4 align-middle fw-bold">
            <thead class="fs-7 text-gray-500 text-uppercase">
            <tr>
              <th class="min-w-250px">{{ 'manageEvent.classes.name' | translate }}</th>
              <th class="min-w-90px">{{ 'manageEvent.classes.startTime' | translate }}</th>
              <th class="min-w-90px">{{ 'manageEvent.classes.timePerParticipant' | translate }}</th>
              <th class="min-w-50px ">{{ 'manageEvent.classes.price' | translate }}</th>
              <th class="min-w-50px ">{{ 'manageEvent.classes.registrations' | translate }}</th>
              <th class="min-w-150px">{{ 'manageEvent.classes.status' | translate }}</th>
              <th class="text-end min-w-70px">{{ 'manageEvent.classes.actions' | translate }}</th>
            </tr>
            </thead>
            <tbody class="fs-6">
            @for (class of filteredClasses; track class.event_class_id) {
              <tr class="cursor-pointer" (click)="openViewRegistrationsModal(class)">
                <td>
                  <div class="d-flex align-items-center">
                    <div class="d-flex flex-column justify-content-center">
                      <span class="fs-6 text-gray-800">{{ class.class_name }}</span>
                      <div class="fw-semibold text-gray-500">{{ class.class?.class_name }}</div>
                    </div>
                  </div>
                </td>
                <td>{{ formatTimeDMYHHMM(class.start_date_time!) }}</td>
                <td>{{ class.time_per_participant_seconds }} min</td>
                <td>{{ class.price }} {{class.price_currency}}</td>
                <td>{{ class.event_class_registrations.length }}</td>
                <td (click)="$event.stopPropagation()">
                  <app-selectorini
                    [options]="EVENT_CLASS_STATUSES"
                    [displayKey]="'labelKey'"
                    [multiple]="false"
                    [value]="class.status"
                    (valueChange)="updateEventClassStatus(class, $event)"
                  />
                </td>
                <td class="text-end" (click)="$event.stopPropagation()">
                  <div class="dropdown">
                    <button
                      class="btn btn-sm btn-icon btn-light btn-active-light-primary"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i class="fa fa-ellipsis-v"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end">
                      <li>
                        <a class="dropdown-item" (click)="openViewRegistrationsModal(class)">
                          <i class="far fa-eye me-2"></i>
                          {{ 'manageEvent.classes.viewRegistrations' | translate }}
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" (click)="openEditEventClassModal(class)">
                          <i class="far fa-edit me-2"></i>
                          {{ 'manageEvent.classes.editClass' | translate }}
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" (click)="openCopyClassModal(class)">
                          <i class="far fa-copy me-2"></i>
                          {{ 'manageEvent.classes.copy' | translate }}
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" (click)="openMembershipPricingModal(class)">
                          <i class="fas fa-tag me-2"></i>
                          {{ 'manageEvent.classes.membershipPricing' | translate }}
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" (click)="openScoringConfigModal(class)">
                          <i class="fas fa-stopwatch me-2"></i>
                          {{ 'scoring.configureScoring' | translate }}
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" (click)="openRoundsConfigModal(class)">
                          <i class="fas fa-layer-group me-2"></i>
                          {{ 'rounds.configureRounds' | translate }}
                        </a>
                      </li>
                      <li><hr class="dropdown-divider"></li>
                      <li>
                        <a class="dropdown-item text-danger" (click)="deleteEventClass(class)">
                          <i class="far fa-trash-can me-2"></i>
                          {{ 'manageEvent.classes.deleteClass' | translate }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
        </div>
      }
    </div>
  </div>
}
